export const superAdminNavigation = [
  {
    label: 'Overview',
    items: [
      { label: 'Dashboard', to: '/sa/dashboard', icon: 'dashboard' },
    ],
  },
  {
    label: 'Operations',
    items: [
      { label: 'Users', to: '/sa/dashboard/individual', icon: 'users' },
      { label: 'Organizations', to: '/sa/organizations', icon: 'organization' },
      { label: 'Communities', to: '/sa/communities', icon: 'community' },
      { label: 'Clubs', to: '/sa/clubs', icon: 'club' },
      { label: 'Cricket Identity', to: '/sa/identity', icon: 'identity' },
      { label: 'Grounds', to: '/sa/grounds', icon: 'grounds' },
    ],
  },
  {
    label: 'Growth & Revenue',
    items: [
      { label: 'First 100 Launch', to: '/sa/launch-commerce', icon: 'launch' },
      { label: 'Growth', to: '/sa/growth', icon: 'growth' },
      { label: 'Offers', to: '/sa/offers', icon: 'offer' },
      { label: 'Commerce', to: '/sa/monetization', icon: 'commerce' },
    ],
  },
  {
    label: 'Engagement',
    items: [
      { label: 'Notifications', to: '/sa/notifications', icon: 'notification' },
    ],
  },
  {
    label: 'Platform',
    items: [
      { label: 'Organization Platform', to: '/sa/organization-platform', icon: 'platform' },
    ],
  },
  {
    label: 'Governance',
    items: [
      { label: 'Platform Settings', to: '/sa/settings', icon: 'settings' },
    ],
  },
];

export const superAdminDestinations = superAdminNavigation.flatMap((group) =>
  group.items.map((item) => ({ ...item, group: group.label }))
);

const entityRoutes = [
  { pattern: /^\/sa\/grounds\/new$/, parent: '/sa/grounds', parentLabel: 'Grounds', label: 'Create' },
  { pattern: /^\/sa\/grounds\/requests$/, parent: '/sa/grounds', parentLabel: 'Grounds', label: 'Availability Requests' },
  { pattern: /^\/sa\/grounds\/bookings$/, parent: '/sa/grounds', parentLabel: 'Grounds', label: 'Bookings' },
  { pattern: /^\/sa\/grounds\/[^/]+\/edit$/, parent: '/sa/grounds', parentLabel: 'Grounds', label: 'Edit' },
  { pattern: /^\/sa\/grounds\/[^/]+$/, parent: '/sa/grounds', parentLabel: 'Grounds', label: 'Details' },
  { pattern: /^\/sa\/organizations\/[^/]+\/admins$/, parent: '/sa/organizations', parentLabel: 'Organizations', label: 'Administrators' },
  { pattern: /^\/sa\/communities\/[^/]+\/admins$/, parent: '/sa/communities', parentLabel: 'Communities', label: 'Administrators' },
  { pattern: /^\/sa\/organizations\/[^/]+$/, parent: '/sa/organizations', parentLabel: 'Organizations', label: 'Details' },
  { pattern: /^\/sa\/communities\/[^/]+$/, parent: '/sa/communities', parentLabel: 'Communities', label: 'Details' },
  { pattern: /^\/sa\/clubs\/[^/]+$/, parent: '/sa/clubs', parentLabel: 'Clubs', label: 'Details' },
];

export const getSuperAdminBreadcrumbs = (pathname) => {
  const entityRoute = entityRoutes.find(({ pattern }) => pattern.test(pathname));
  if (entityRoute) {
    return [
      { label: 'Super Admin', to: '/sa/dashboard' },
      { label: entityRoute.parentLabel, to: entityRoute.parent },
      { label: entityRoute.label },
    ];
  }

  const destination = superAdminDestinations.find(({ to }) => pathname === to);
  return [
    { label: 'Super Admin', to: '/sa/dashboard' },
    { label: destination?.label || 'Workspace' },
  ];
};
